import React from 'react'
import { QuizQuestionWrapper } from '../../QuizQuestionWrapper'
import { OutlinedTextField } from 'src/common/components'
import { useYourDetails } from './YourDetails.hook'
import { ReactComponent as CheerIcon } from 'src/assets/icons/cheer-icon.svg'
import './YourDetails.scss'
import { useLocation } from 'react-router-dom'
import { QuizType } from 'src/pages/shared'

const disabledDays = new Date()
disabledDays.setDate(disabledDays.getDate() + 1)

export const YourDetails = () => {
  const query = new URLSearchParams(useLocation().search)
  const isPinterestFlow = query.get('quizType') === QuizType.PINTEREST
  const { weddingDateData, nextDisabled, formError, handleNext, handleBack, handleChangeInput } = useYourDetails(
    query.get('quizType') as QuizType
  )

  const renderYourName = () => {
    return (
      <OutlinedTextField
        wrapperClass="mb-10px"
        id="fullNameId"
        value={weddingDateData.fullName || ''}
        type="text"
        name="fullName"
        onChange={handleChangeInput}
        label={isPinterestFlow ? 'Your full name' : 'Your name'}
        isError={formError.fullName}
        errorMsg="Your name is required!"
      />
    )
  }

  const renderPartnerName = () => {
    return (
      <OutlinedTextField
        wrapperClass="mb-10px"
        id="partnerName"
        value={weddingDateData.partnerName || ''}
        type="text"
        name="partnerName"
        onChange={handleChangeInput}
        label={isPinterestFlow ? `Partner's full name` : "Partner's name"}
        isError={formError.partnerName}
        errorMsg="Your partner's name is required!"
      />
    )
  }

  return (
    <>
      <QuizQuestionWrapper
        titleStep="YOUR DETAILS"
        title="We're available!"
        titleIcon={isPinterestFlow ? <CheerIcon /> : undefined}
        nextAction={{
          disabled: true,
        }}
        backAction={{
          onAction: handleBack,
        }}
        customCss={{
          title: 'title-bold',
          content: 'your-details-wrapper',
        }}
        step={3}
        total={7}
        className={isPinterestFlow ? 'pinterest-flow your-details' : ''}
        quizType={query.get('quizType') as QuizType}
      >
        <div className={`your-details-section mb-30px ${isPinterestFlow ? '' : 'mt-24px'}`}>
          <div className="form-title">Who’s getting married?</div>
          <div className="customer-name">{renderYourName()}</div>
          <div className="partner-name">{renderPartnerName()}</div>
          <div className="action-box-wrapper">
            <button disabled={nextDisabled} className={`button`} onClick={handleNext}>
              Next
            </button>
          </div>
        </div>
      </QuizQuestionWrapper>
    </>
  )
}
